import {
  Avatar,
  AvatarImage,
  AvatarFallback,
  Button,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Badge,
} from '@wove/web-ui'
import { UserWithRole } from '@wove/api/types'
import { Trash2 } from 'lucide-react'
import { useAuth } from '@src/hooks/useAuth'
import { useDeactivateUsersMutation } from '@wove/api'
import { useCallback } from 'react'

const getStatusBadge = (status: 'active' | 'inactive' | 'invited') => {
  switch (status) {
    case 'active':
      return (
        <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
          Active
        </Badge>
      )
    case 'invited':
      return (
        <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
          Invited
        </Badge>
      )
    case 'inactive':
      return (
        <Badge variant="outline" className="bg-gray-50 text-gray-700 border-gray-200">
          Inactive
        </Badge>
      )
    default:
      return null
  }
}

const UserRow = ({
  member,
  changeRole,
}: {
  member: UserWithRole
  changeRole: (id: string, role: string) => void
}) => {
  const auth = useAuth()
  const [, executeDeactivate] = useDeactivateUsersMutation()
  const onDeactivate = useCallback(() => {
    executeDeactivate({ userId: member.id })
  }, [executeDeactivate, member.id])
  return (
    <div key={member.id} className="flex items-center justify-between p-4 border rounded-lg">
      <div className="flex items-center space-x-4">
        <Avatar>
          <AvatarImage src={''} alt={member.firstName + ' ' + member.lastName} />
          <AvatarFallback>{member.firstName[0] + member.lastName?.[0] || ''}</AvatarFallback>
        </Avatar>
        <div>
          <p className="font-medium">
            {member.firstName} {member.lastName}
          </p>
          <p className="text-sm text-muted-foreground">{member.email}</p>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        {getStatusBadge(member.deactivatedAt ? 'inactive' : 'active')}
        <Select
          value={member.role}
          onValueChange={(value) => changeRole(member.id, value)}
          disabled
        >
          <SelectTrigger className="w-[110px]" disabled>
            <SelectValue placeholder="Select role" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="admin">Admin</SelectItem>
            <SelectItem value="general">General</SelectItem>
            <SelectItem value="core">Core</SelectItem>
          </SelectContent>
        </Select>
        {member.id !== auth.user?.id && !member.deactivatedAt && (
          <Button variant="ghost" size="icon" onClick={onDeactivate}>
            <Trash2 className="h-4 w-4 text-muted-foreground" />
          </Button>
        )}
      </div>
    </div>
  )
}

export default UserRow
